import React from "react";
import "./BonusTrimestral.css";

const formatarMoeda = (valor) => {
  const numero = typeof valor === "string"
    ? Number(valor.replace(/\./g, "").replace(",", "."))
    : typeof valor === "number"
      ? valor
      : 0;

  if (isNaN(numero)) return "R$ 0,00";

  return numero.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BonusTrimestral = ({
  valorAtual,
  valorMeta,
  dataAtualizacao
}) => {
  const percentual = valorMeta
    ? Math.min(100, Math.round((valorAtual / valorMeta) * 100))
    : 0;

  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-12">
          <h3 className="card-title text-dark font-weight-bold mb-4">Bônus Trimestral</h3>

          <p className="mb-2">Progresso rumo ao bônus:</p>

          <div className="bonus-progress-container mb-2" >
            <div
              className="bonus-progress-bar"
              role="progressbar"
              style={{
                width: `${percentual}%`,
                backgroundColor: "#f26324",
                fontWeight: "bold"
              }}
              aria-valuenow={percentual}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {percentual}%
            </div>
          </div>

          <p className="mb-3 text-muted">
            {formatarMoeda(valorAtual)} de {formatarMoeda(valorMeta)} ({percentual}%)
          </p>

          <div className="d-flex align-items-center text-muted">
            <i className="fas fa-clock mr-2 text-warning"></i>
            <small>Atualizado em: {dataAtualizacao}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BonusTrimestral;
